import React from 'react';
import { Button, Icon, CountBadge } from '../../components/ui';
import CampaignAccessMenu, { LockedBadge } from '../../components/CampaignAccessMenu';
import { fmtDate } from './derive';

export const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'questions', label: 'Question bank', countKey: 'questions' },
  { id: 'interviews', label: 'Interviews', countKey: 'interviews' },
  { id: 'candidates', label: 'Candidates', countKey: 'candidates' },
];

/** Old ?tab= values keep working. */
export const TAB_ALIASES = { details: 'overview', exam: 'interviews' };

export function normalizeTab(t) {
  const id = TAB_ALIASES[t] || t;
  return TABS.some((x) => x.id === id) ? id : 'overview';
}

export const languageLabel = (lang) => (lang === 'es' ? 'Spanish (Bilingual)' : 'English');

export function difficultyText(level) {
  const d = String(level || 'medium').toLowerCase();
  return d.charAt(0).toUpperCase() + d.slice(1);
}

export function connectedToLabel(sourceTool) {
  if (!sourceTool) return null;
  if (sourceTool === 'reachout') return 'ReachOut';
  if (sourceTool === 'codesense') return 'Codesense';
  return sourceTool;
}

/** Prototype .pos-head: back link, title row, meta line, actions, tabs. */
export default function PositionHeader({ campaign, hireBar, counts, activeTab, onTab, onBack, onEdit, onAccessChanged }) {
  const code = (campaign.job_code || '').trim();
  const connected = connectedToLabel(campaign.source_tool);
  return (
    <section className="wz-pos-head">
      <button type="button" className="wz-back" onClick={onBack}>
        <Icon name="chevL" />All positions
      </button>
      <div className="wz-pos-row">
        <div>
          <div className="wz-pos-title">
            <h1>{campaign.name}</h1>
            {code && <span className="wz-code wz-mono">{code}</span>}
            <span className={`wz-status wz-pos-status ${campaign.is_active ? 'on' : 'off'}`}>
              <span className="wz-dot" style={{ background: campaign.is_active ? 'var(--wz-pass-dot)' : 'var(--wz-ghost)', width: 6, height: 6 }} />
              {campaign.is_active ? 'Active' : 'Inactive'}
            </span>
            <LockedBadge campaign={campaign} />
          </div>
          <div className="wz-meta">
            <span>{languageLabel(campaign.language)}</span>
            <span>{difficultyText(campaign.difficulty_level)} difficulty</span>
            {connected && <span>Connected to {connected}</span>}
            {campaign.created_at && <span>Created {fmtDate(campaign.created_at)}</span>}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button need="campaign.edit" variant="primary" onClick={onEdit}>Edit position</Button>
          <CampaignAccessMenu campaign={campaign} onChanged={onAccessChanged} />
        </div>
      </div>
      <nav className="wz-tabs" aria-label="Position sections">
        {TABS.map((t) => {
          const n = t.countKey ? counts?.[t.countKey] : null;
          return (
            <a
              key={t.id}
              className="wz-tab"
              href={`?tab=${t.id}`}
              aria-current={activeTab === t.id ? 'page' : undefined}
              onClick={(e) => { e.preventDefault(); onTab(t.id); }}
            >
              {t.label}
              {n != null && <CountBadge>{n}</CountBadge>}
            </a>
          );
        })}
      </nav>
    </section>
  );
}
